const REF_CODE = "refCode";

export default REF_CODE;
